import anime from "animejs";
import CountUp from "countup.js";
import { $1, each } from "../util";

require("waypoints/lib/noframework.waypoints.min");

const ScrollAnimations = (() => {
  let firstNumAnim;
  let secondNumAnim;
  let thirdNumAnim;
  let fourthNumAnim;

  let lastNumAnim;

  const hideHome = () => {
    const home = document.getElementById("home");

    if (home) {
      const hideUp = home.querySelectorAll(".js-hide-up");
      const hideDown = home.querySelectorAll(".js-hide-down");
      const hideLeft = home.querySelectorAll(".js-hide-left");

      const options = {
        separator: "'",
      };

      const firstNumber = home.querySelector(".js-home-first-number");
      const secondNumber = home.querySelector(".js-home-second-number");
      const thirdNumber = home.querySelector(".js-home-third-number");
      const fourthNumber = home.querySelector(".js-home-fourth-number");
      const lastNumber = home.querySelector(".js-home-last-number");

      const firstEndValue = firstNumber.dataset.end;
      firstNumAnim = new CountUp(
        firstNumber,
        0,
        firstEndValue,
        0,
        1.5,
        options
      );

      const secondEndValue = secondNumber.dataset.end;
      secondNumAnim = new CountUp(
        secondNumber,
        0,
        secondEndValue,
        0,
        1.5,
        options
      );
      const thirdEndValue = thirdNumber.dataset.end;
      thirdNumAnim = new CountUp(
        thirdNumber,
        0,
        thirdEndValue,
        0,
        1.5,
        options
      );
      const fourthEndValue = fourthNumber.dataset.end;
      fourthNumAnim = new CountUp(
        fourthNumber,
        0,
        fourthEndValue,
        0,
        1.5,
        options
      );
      const lastEndValue = lastNumber.dataset.end;
      lastNumAnim = new CountUp(lastNumber, 0, lastEndValue, 0, 1.5, options);
      anime({
        targets: hideUp,
        translateY: "-12px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: hideDown,
        translateY: "-12px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: hideLeft,
        translateX: "-12px",
        opacity: 0,
        duration: 0,
      });
    }
  };

  const onHomeScroll = () => {
    const homeMainSection = $1(".c-home__main-section");
    const homeMainSlider = $1(".c-home__main-slider");
    const homeCasePreview = $1(".js-home-case-preview");
    const homeBlogPreview = $1(".js-home-blog-preview");
    const homeScrollViewer = $1(".c-scroll-viewer");
    const homeCtaBlock = $1(".js-cta-block-reveal");

    if (homeMainSection) {
      const hideUp = homeMainSection.querySelectorAll(".js-hide-up");
      const hideDown = homeMainSection.querySelectorAll(".js-hide-down");

      const firstHomeTl = anime.timeline();

      const firstHomePoint = new Waypoint({
        element: document.querySelector(".c-home__main-section"),
        handler: function () {
          firstHomeTl
            .add({
              targets: hideUp,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              duration: 400,
            })
            .add({
              targets: hideDown,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
              complete: () => {
                if (!firstNumAnim.error) {
                  firstNumAnim.start(() => {
                    this.destroy();
                  });
                  secondNumAnim.start(() => {
                    this.destroy();
                  });
                  thirdNumAnim.start(() => {
                    this.destroy();
                  });
                  lastNumAnim.start(() => {
                    this.destroy();
                  });
                } else {
                  console.error(firstNumAnim.error, secondNumAnim.error);
                }

                this.destroy();
              },
            });
        },
        offset: "70%",
      });
    }

    if (homeMainSlider) {
      const hideUp = homeMainSlider.querySelectorAll(".js-hide-up");
      const hideDown = homeMainSlider.querySelectorAll(".js-hide-down");
      const hideLeft = homeMainSlider.querySelectorAll(".js-hide-left");

      const secondHomeTl = anime.timeline();

      const secondHomePoint = new Waypoint({
        element: document.querySelector(".c-home__main-section"),
        handler: function () {
          secondHomeTl
            .add({
              targets: hideUp,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
            })
            .add({
              targets: hideLeft,
              translateX: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              duration: 400,
            })
            .add({
              targets: hideDown,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
              complete: () => {
                this.destroy();
              },
            });
        },
        offset: "5%",
      });
    }

    if (homeCasePreview) {
      const hideLeft = homeCasePreview.querySelectorAll(".js-hide-left");

      const thirdHomeTl = anime.timeline();
      const thirdHomePoint = new Waypoint({
        element: document.querySelector(".js-home-case-preview"),
        handler: function () {
          thirdHomeTl.add({
            targets: hideLeft,
            translateX: {
              value: "0%",
              easing: [0.694, 0.048, 0.335, 1.0],
            },
            opacity: {
              value: 1,
              easing: "linear",
            },
            delay: (target, index) => index * 100,
            duration: 400,
            complete: () => {
              this.destroy();
            },
          });
        },
        offset: "60%",
      });
    }

    if (homeBlogPreview) {
      const hideLeft = homeBlogPreview.querySelectorAll(".js-hide-left");

      const thirdHomeTl = anime.timeline();
      const thirdHomePoint = new Waypoint({
        element: document.querySelector(".js-home-blog-preview"),
        handler: function () {
          thirdHomeTl.add({
            targets: hideLeft,
            translateX: {
              value: "0%",
              easing: [0.694, 0.048, 0.335, 1.0],
            },
            opacity: {
              value: 1,
              easing: "linear",
            },
            delay: (target, index) => index * 100,
            duration: 400,
            complete: () => {
              this.destroy();
            },
          });
        },
        offset: "60%",
      });
    }

    if (homeScrollViewer) {
      const hideUp = homeScrollViewer.querySelectorAll(".js-hide-up");
      const hideDown = homeScrollViewer.querySelectorAll(".js-hide-down");

      const fourthHomeTl = anime.timeline();
      const fourthHomePoint = new Waypoint({
        element: document.querySelector(".js-home-scroll-viewer"),
        handler: function () {
          fourthHomeTl
            .add({
              targets: hideDown,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 30,
              duration: 500,
            })
            .add({
              targets: hideUp,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 50,
              duration: 400,
              offset: "-=600",
              complete: () => {
                this.destroy();
              },
            });
        },
        offset: "50%",
      });
    }

    if (homeCtaBlock) {
      const hideDown = homeCtaBlock.querySelectorAll(".js-hide-down");

      const lastHomeTl = anime.timeline();
      const lastHomePoint = new Waypoint({
        element: document.querySelector(".js-cta-block-reveal"),
        handler: function () {
          lastHomeTl.add({
            targets: hideDown,
            translateY: {
              value: "-50%",
              easing: [0.694, 0.048, 0.335, 1.0],
            },
            opacity: {
              value: 1,
              easing: "linear",
            },
            delay: (target, index) => index * 30,
            duration: 500,
            complete: () => {
              this.destroy();
            },
          });
        },
        offset: "20%",
      });
    }
  };

  const hideAbout = () => {
    const who = document.getElementById("who");

    if (who) {
      const hideUp = who.querySelectorAll(".js-hide-up");
      const hideDown = who.querySelectorAll(".js-hide-down");
      const hideLeft = who.querySelectorAll(".js-hide-left");

      anime({
        targets: hideUp,
        translateY: "-12px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: hideDown,
        translateY: "-12px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: hideLeft,
        translateX: "-12px",
        opacity: 0,
        duration: 0,
      });
    }
  };

  const onWhoScroll = () => {
    const sectionFirst = $1(".js-who-first");
    const whoCasePreview = $1(".js-who-case-preview");
    const whoGeneral = $1(".js-who-general-section");
    const whoCtaBlock = $1(".js-cta-block-reveal");

    if (sectionFirst) {
      const hideUp = sectionFirst.querySelectorAll(".js-hide-up");
      const hideDown = sectionFirst.querySelectorAll(".js-hide-down");

      const firstWhoTl = anime.timeline();

      const firstWhoPoint = new Waypoint({
        element: document.querySelector(".js-who-first"),
        handler: function () {
          firstWhoTl
            .add({
              targets: hideUp,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
            })
            .add({
              targets: hideDown,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
              complete: () => {
                this.destroy();
              },
            });
        },
        offset: "40%",
      });
    }

    if (whoCasePreview) {
      const hideLeft = whoCasePreview.querySelectorAll(".js-hide-left");

      const secondWhoTl = anime.timeline();

      const secondWhoPoint = new Waypoint({
        element: document.querySelector(".js-who-case-preview"),
        handler: function () {
          secondWhoTl.add({
            targets: hideLeft,
            translateX: {
              value: "0%",
              easing: [0.694, 0.048, 0.335, 1.0],
            },
            opacity: {
              value: 1,
              easing: "linear",
            },
            delay: (target, index) => index * 100,
            duration: 400,
            complete: () => {
              this.destroy();
            },
          });
        },
        offset: "60%",
      });
    }

    if (whoGeneral) {
      const hideUp = whoGeneral.querySelectorAll(".js-hide-up");
      const hideDown = whoGeneral.querySelectorAll(".js-hide-down");
      const hideLeft = whoGeneral.querySelectorAll(".js-hide-left");

      const thirdWhoTl = anime.timeline();

      const thirdWhoPoint = new Waypoint({
        element: document.querySelector(".js-who-general-section"),
        handler: function () {
          thirdWhoTl
            .add({
              targets: hideUp,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
            })
            .add({
              targets: hideLeft,
              translateX: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
            })
            .add({
              targets: hideDown,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
              complete: () => {
                this.destroy();
              },
            });
        },
        offset: "80%",
      });
    }

    if (whoCtaBlock) {
      const hideDown = whoCtaBlock.querySelectorAll(".js-hide-down");

      const lastHomeTl = anime.timeline();
      const lastHomePoint = new Waypoint({
        element: document.querySelector(".js-cta-block-reveal"),
        handler: function () {
          lastHomeTl.add({
            targets: hideDown,
            translateY: {
              value: "-50%",
              easing: [0.694, 0.048, 0.335, 1.0],
            },
            opacity: {
              value: 1,
              easing: "linear",
            },
            delay: (target, index) => index * 30,
            duration: 500,
            complete: () => {
              this.destroy();
            },
          });
        },
        offset: "30%",
      });
    }
  };

  const hideCase = () => {
    const casePage = document.getElementById("case");

    if (casePage) {
      const hideUp = casePage.querySelectorAll(".js-hide-up");
      const hideDown = casePage.querySelectorAll(".js-hide-down");
      const hideLeft = casePage.querySelectorAll(".js-hide-left");
      const caseImage = casePage.querySelectorAll(".c-case__image");

      anime({
        targets: hideUp,
        translateY: "-12px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: hideDown,
        translateY: "-12px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: caseImage,
        translateY: "-12px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: hideLeft,
        translateX: "-12px",
        opacity: 0,
        duration: 0,
      });
    }
  };

  const onCaseScroll = () => {
    const casePage = document.getElementById("case");
    const firstCase = $1(".js-case-first");
    const thirdCase = $1(".js-case-third");
    const fourthCase = $1(".js-case-fourth");
    const fifthCase = $1(".js-case-fifth");
    const relatedProjects = $1(".js-related-projects");

    if (firstCase) {
      const hideUp = firstCase.querySelectorAll(".js-hide-up");

      const firstCaseTl = anime.timeline();

      const firstCasePoint = new Waypoint({
        element: document.querySelector(".js-case-first"),
        handler: function () {
          firstCaseTl.add({
            targets: hideUp,
            translateY: {
              value: "0%",
              easing: [0.694, 0.048, 0.335, 1.0],
            },
            opacity: {
              value: 1,
              easing: "linear",
            },
            delay: (target, index) => index * 100,
            duration: 400,
            complete: () => {
              this.destroy();
            },
          });
        },
        offset: "80%",
      });
    }

    if (casePage) {
      const caseImages = casePage.querySelectorAll(".c-case__image");

      each(caseImages, (i, caseImage) => {
        const caseTl = anime.timeline();

        const casePoint = new Waypoint({
          element: caseImage,
          handler: function () {
            caseTl.add({
              targets: caseImage,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
              complete: () => {
                this.destroy();
              },
            });
          },
          offset: "30%",
        });
      });
    }

    if (thirdCase) {
      const hideUp = thirdCase.querySelectorAll(".js-hide-up");

      const thirdCaseTl = anime.timeline();

      const thirdCasePoint = new Waypoint({
        element: document.querySelector(".js-case-third"),
        handler: function () {
          thirdCaseTl.add({
            targets: hideUp,
            translateY: {
              value: "0%",
              easing: [0.694, 0.048, 0.335, 1.0],
            },
            opacity: {
              value: 1,
              easing: "linear",
            },
            delay: (target, index) => index * 100,
            duration: 400,
            complete: () => {
              this.destroy();
            },
          });
        },
        offset: "30%",
      });
    }

    if (fourthCase) {
      const hideUp = fourthCase.querySelectorAll(".js-hide-up");

      const fourthCaseTl = anime.timeline();

      const fourthCasePoint = new Waypoint({
        element: document.querySelector(".js-case-fourth"),
        handler: function () {
          fourthCaseTl.add({
            targets: hideUp,
            translateY: {
              value: "0%",
              easing: [0.694, 0.048, 0.335, 1.0],
            },
            opacity: {
              value: 1,
              easing: "linear",
            },
            delay: (target, index) => index * 100,
            duration: 400,
            complete: () => {
              this.destroy();
            },
          });
        },
        offset: "60%",
      });
    }

    if (fifthCase) {
      const hideUp = fifthCase.querySelectorAll(".js-hide-up");
      const hideLeft = fifthCase.querySelectorAll(".js-hide-left");

      const fifthCaseTl = anime.timeline();

      const fifthCasePoint = new Waypoint({
        element: document.querySelector(".js-case-fifth"),
        handler: function () {
          fifthCaseTl
            .add({
              targets: hideUp,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
            })
            .add({
              targets: hideLeft,
              translateX: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
              complete: () => {
                this.destroy();
              },
            });
        },
        offset: "30%",
      });
    }

    if (relatedProjects) {
      const hideUp = relatedProjects.querySelectorAll(".js-hide-up");
      const hideLeft = relatedProjects.querySelectorAll(".js-hide-left");

      const lastCaseTl = anime.timeline();
      const lastCasePoint = new Waypoint({
        element: document.querySelector(".js-related-projects"),
        handler: function () {
          lastCaseTl
            .add({
              targets: hideUp,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 30,
              duration: 500,
            })
            .add({
              targets: hideLeft,
              translateX: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 50,
              duration: 500,
              complete: () => {
                this.destroy();
              },
            });
        },
        offset: "30%",
      });
    }
  };

  const hideListCases = () => {
    const caseList = document.getElementById("case-list");

    if (caseList) {
      const hideUp = caseList.querySelectorAll(".js-hide-up");
      const hideDown = caseList.querySelectorAll(".js-hide-down");

      anime({
        targets: hideUp,
        translateY: "-12px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: hideDown,
        translateY: "12px",
        opacity: 0,
        duration: 0,
      });
    }
  };

  const onListCasesScroll = () => {
    const caseList = document.getElementById("case-list");

    if (caseList) {
      const caseHistories = caseList.querySelectorAll(".c-case-history");
      const caseFirst = $1(".js-case-first");
      const caseCtaBlock = $1(".js-cta-block-reveal");

      if (caseFirst) {
        const caseFirstTl = anime.timeline();
        const hideUp = caseFirst.querySelectorAll(".js-hide-up");

        // const caseFirstPoint = new Waypoint({
        //   element: hideUp,
        //   handler: function() {
        //     caseFirstTl
        //       .add({
        //         targets: caseFirst,
        //         translateY: {
        //           value: '0%',
        //           easing: [0.694, 0.048, 0.335, 1.000],
        //         },
        //         opacity: {
        //           value: 1,
        //           easing: 'linear',
        //         },
        //         delay: (target, index) => index * 100,
        //         duration: 400,
        //         complete: () => {
        //           this.destroy()
        //         },
        //       })
        //   },
        //   offset: '60%',
        // })
      }

      each(caseHistories, (i, caseHistory) => {
        const hideUp = caseHistory.querySelectorAll(".js-hide-up");
        const caseTl = anime.timeline();

        const casePoint = new Waypoint({
          element: caseHistory,
          handler: function () {
            caseTl.add({
              targets: hideUp,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 50,
              duration: 400,
              complete: () => {
                this.destroy();
              },
            });
          },
          offset: "70%",
        });
      });

      if (caseCtaBlock) {
        const hideDown = caseCtaBlock.querySelectorAll(".js-hide-down");

        const caseCtaBlockTl = anime.timeline();
        const caseCtaBlockPoint = new Waypoint({
          element: document.querySelector(".js-cta-block-reveal"),
          handler: function () {
            caseCtaBlockTl.add({
              targets: hideDown,
              translateY: {
                value: "-50%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 30,
              duration: 500,
              complete: () => {
                this.destroy();
              },
            });
          },
          offset: "30%",
        });
      }
    }
  };

  const hideProduct = () => {
    const product = document.getElementById("prodotto");

    if (product) {
      const hideUp = product.querySelectorAll(".js-hide-up");
      const hideDown = product.querySelectorAll(".js-hide-down");
      const hideLeft = product.querySelectorAll(".js-hide-left");

      anime({
        targets: hideUp,
        translateY: "-12px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: hideDown,
        translateY: "-12px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: hideLeft,
        translateX: "-12px",
        opacity: 0,
        duration: 0,
      });
    }
  };

  const onProductScroll = () => {
    const product = document.getElementById("prodotto");

    if (product) {
      const firstProduct = $1(".js-product-first");
      const secondProduct = $1(".js-product-second");
      const thirdProduct = $1(".js-product-third");
      const fourthProduct = $1(".js-product-fourth");

      if (firstProduct) {
        const hideUp = firstProduct.querySelectorAll(".js-hide-up");

        const firstProductTl = anime.timeline();

        const firstProductPoint = new Waypoint({
          element: document.querySelector(".js-product-first"),
          handler: function () {
            firstProductTl.add({
              targets: hideUp,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
              complete: () => {
                this.destroy();
              },
            });
          },
          offset: "70%",
        });
      }

      if (secondProduct) {
        const hideDown = secondProduct.querySelectorAll(".js-hide-down");
        const hideLeft = secondProduct.querySelectorAll(".js-hide-left");

        const secondProductTl = anime.timeline();

        const secondProductPoint = new Waypoint({
          element: document.querySelector(".js-product-second"),
          handler: function () {
            secondProductTl
              .add({
                targets: hideLeft,
                translateX: {
                  value: "0%",
                  easing: [0.694, 0.048, 0.335, 1.0],
                },
                opacity: {
                  value: 1,
                  easing: "linear",
                },
                delay: (target, index) => index * 100,
                duration: 400,
              })
              .add({
                targets: hideDown,
                translateY: {
                  value: "0%",
                  easing: [0.694, 0.048, 0.335, 1.0],
                },
                opacity: {
                  value: 1,
                  easing: "linear",
                },
                delay: (target, index) => index * 100,
                duration: 400,
                complete: () => {
                  this.destroy();
                },
              });
          },
          offset: "70%",
        });
      }

      if (thirdProduct) {
        const hideDown = thirdProduct.querySelectorAll(".js-hide-down");
        const hideLeft = thirdProduct.querySelectorAll(".js-hide-left");

        const thirdProductTl = anime.timeline();

        const thirdProductPoint = new Waypoint({
          element: document.querySelector(".js-product-third"),
          handler: function () {
            thirdProductTl
              .add({
                targets: hideLeft,
                translateX: {
                  value: "0%",
                  easing: [0.694, 0.048, 0.335, 1.0],
                },
                opacity: {
                  value: 1,
                  easing: "linear",
                },
                delay: (target, index) => index * 100,
                duration: 400,
              })
              .add({
                targets: hideDown,
                translateY: {
                  value: "0%",
                  easing: [0.694, 0.048, 0.335, 1.0],
                },
                opacity: {
                  value: 1,
                  easing: "linear",
                },
                delay: (target, index) => index * 100,
                duration: 400,
                complete: () => {
                  this.destroy();
                },
              });
          },
          offset: "70%",
        });
      }

      if (fourthProduct) {
        const hideDown = fourthProduct.querySelectorAll(".js-hide-down");

        const fourthProductTl = anime.timeline();

        const fourthProductPoint = new Waypoint({
          element: document.querySelector(".js-product-fourth"),
          handler: function () {
            fourthProductTl.add({
              targets: hideDown,
              translateY: {
                value: "0%",
                easing: [0.694, 0.048, 0.335, 1.0],
              },
              opacity: {
                value: 1,
                easing: "linear",
              },
              delay: (target, index) => index * 100,
              duration: 400,
              complete: () => {
                this.destroy();
              },
            });
          },
          offset: "35%",
        });
      }
    }
  };

  const hideDOM = () => {
    hideHome();
    hideAbout();
    hideCase();
    hideListCases();
    hideProduct();
  };

  const init = () => {
    onHomeScroll();
    onWhoScroll();
    onCaseScroll();
    onListCasesScroll();
    onProductScroll();
  };

  return {
    hideDOM,
    init,
  };
})();

export default ScrollAnimations;
